import type { Medication } from '@medplum/fhirtypes';

import { Text } from '@eluve/components';

import type { FhirView } from '../../core/view-contract';
import { resourceDisplayName } from '../accessors';

/**
 * Medication is a reference target, not a section: it renders as the
 * medication's name inline wherever a MedicationRequest (or similar) places
 * its slot. Form rides along when coded.
 */
export const MedicationView: FhirView<Medication> = ({ data }) => {
  const form = data.form?.text;
  return (
    <Text
      inline
      size="sm"
      weight="regular"
      className="truncate"
      data-view="medication-inline"
    >
      {resourceDisplayName(data)}
      {form ? ` (${form})` : ''}
    </Text>
  );
};
